<router-outlet></router-outlet>
<app-loader />
<app-splash *ngIf="showSplash" />
